import { defineType } from "sanity";
import { multilingualStringPreview } from "../base/multilingualString";

export default defineType({
  name: "accordionContent",
  type: "object",
  title: "Accordion Content",
  fields: [
    {
      name: "title",
      type: "multilingualArrayString",
      title: "Title"
    },
    {
      name: "content",
      type: "multilingualArrayText",
      title: "Content"
    }
  ],
  preview: {
    select: {
      title: "title"
    },
    prepare({ title }) {
      return {
        title: multilingualStringPreview(title)
      };
    }
  }
});
